import { render, staticRenderFns } from "./PaymentAtlasModal.vue?vue&type=template&id=b5d600e2&scoped=true&"
import script from "./PaymentAtlasModal.vue?vue&type=script&lang=js&"
export * from "./PaymentAtlasModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAtlasModal.vue?vue&type=style&index=0&id=b5d600e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d600e2",
  null
  
)

export default component.exports